import { useEffect } from "react";

interface PageMeta {
  title: string;
  description: string;
}

const setMetaTag = (selector: string, content: string) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute("content", content);
};

export const usePageMeta = ({ title, description }: PageMeta) => {
  useEffect(() => {
    document.title = title;

    setMetaTag('meta[name="description"]', description);

    setMetaTag('meta[property="og:title"]', title);
    setMetaTag('meta[property="og:description"]', description);

    setMetaTag('meta[property="twitter:title"]', title);
    setMetaTag('meta[property="twitter:description"]', description);

    return () => {
      const defaultTitle = "Directori de cotxes | Cotx.es";
      const defaultDesc = "Directori de marques i models de cotxes. Cerca fàcilment per marca, model, combustible, preu i dimensions.";
      document.title = defaultTitle;
      setMetaTag('meta[name="description"]', defaultDesc);
      setMetaTag('meta[property="og:title"]', defaultTitle);
      setMetaTag('meta[property="og:description"]', defaultDesc);
      setMetaTag('meta[property="twitter:title"]', defaultTitle);
      setMetaTag('meta[property="twitter:description"]', defaultDesc);
    };
  }, [title, description]);
};
